import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import { ModalContext } from '@domain-group/suit-theme'

import handleCallbackAction, { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateAgencyModal from '@modals/CreateAgencyModal'

import PageContent from './components/PageContent'

const callbacks = (component: keyof typeof componentCallbacks, setState: Function) => {
  const componentCallbacks = {
    CreateAgencyModal: {
      closeModal: () => setState({ showCreateAgencyModal: false }),
      createAgency: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateAgencyModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateAgencyModal } = state

  const filterPayload = useFilters({ persistFilters: true, persistedExternalFilterKeys: ['active'] })
  const { callbacks: filterCallbacks, defaultFilters } = filterPayload

  const modalContext = useModals({ setState })

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateAgencyModal: () => setState({ showCreateAgencyModal: true }),
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent filterPayload={filterPayload} />
        {/*
       // @ts-expect-error TS2741 */}
        <CreateAgencyModal
          callbacks={callbacks('CreateAgencyModal', setState)}
          showModal={showCreateAgencyModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
